import { render, staticRenderFns } from "./DsfUserHome.vue?vue&type=template&id=b73a0d5c&"
import script from "./DsfUserHome.vue?vue&type=script&lang=js&"
export * from "./DsfUserHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfUserHome.vue"
export default component.exports